/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_3Inputs */

const vi_irrigation_weekday_3 = /** @type {(inputs: Irrigation_Weekday_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T4`)
};

/**

* @param {Irrigation_Weekday_3Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_3 = /** @type {((inputs?: Irrigation_Weekday_3Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_3Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_3(inputs)
});